<template>
  <div class="dashboardBox">
    <div class="flexBox">
      <div class="flexInner">
        <div class="dashboard summary">
          <p class="boxTitle">{{locale.analytics_users_period}}</p>
          <div class="value">{{comma(totalUsers)}} {{locale.analytics_unit_people}}</div>
        </div>
      </div>
      <div class="flexInner">
        <div class="dashboard summary">
          <p class="boxTitle">{{locale.analytics_views_period}}</p>
          <div class="value">{{comma(totalViews)}} {{locale.analytics_unit_views}}</div>
        </div>
      </div>
      <div class="flexInner">
        <div class="dashboard summary">
          <p class="boxTitle">{{locale.analytics_views_avg}}</p>
          <div class="value">{{totalAvg}} {{locale.analytics_unit_views}}</div>
        </div>
      </div>
    </div>
    <div class="flexBox">
      <div class="flexInner">
        <div v-if="users" class="dashboard">
          <p class="boxTitle mb15">{{locale.analytics_date_users}}</p>
          <div class="chartBox lineChart">
            <line-chart
              :data="users"
              :width="'100%'"
              :colors="['#76b955']"
              :label-rotate="true" />
          </div>
        </div>
        <div v-else class="dashboard noData">{{locale.message_loading_data}}</div>
      </div>
      <div class="flexInner">
        <div v-if="views" class="dashboard">
          <p class="boxTitle mb15">{{locale.analytics_date_views}}</p>
          <div class="chartBox lineChart">
            <line-chart
              :data="views"
              :width="'100%'"
              :colors="['#de5c5c']"
              :label-rotate="true" />
          </div>
        </div>
        <div v-else class="dashboard noData">{{locale.message_loading_data}}</div>
      </div>
    </div>
    <div class="flexBox">
      <div class="flexInner">
        <div v-if="days" class="dashboard">
          <p class="boxTitle mb15">{{locale.analytics_dayofweek_views}}</p>
          <div class="chartBox lineChart">
            <line-chart
              :data="days"
              :width="'100%'"
              :colors="['#a367bb']" />
          </div>
        </div>
        <div v-else class="dashboard noData">{{locale.message_loading_data}}</div>
      </div>
      <div class="flexInner">
        <div v-if="hours" class="dashboard">
          <p class="boxTitle mb15">{{locale.analytics_time_views}}</p>
          <div class="chartBox lineChart">
            <line-chart
              :data="hours"
              :width="'100%'"
              :colors="['#4da2cc']" />
          </div>
        </div>
        <div v-else class="dashboard noData">{{locale.message_loading_data}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { LineChart, PieChart } from 'dr-vue-echarts'
import regExp from '@/common/regExp'
import moment from 'moment/moment'
import Datetime from 'vue-datetime/src/Datetime.vue'

export default {
  name: 'Visitor',
  props: [
    'locale',
    'users',
    'views',
    'days',
    'hours'
  ],
  components: {
    LineChart
  },
  computed: {
    barChartType () {
      return this.chartType === 'bar_h' ? 'horizontal' : ''
    },
    totalUsers () {
      const users = this.users && this.users[0].data.map(x => x.value)
      return users ? this.getSum(users) : null
    },
    totalViews () {
      const views = this.views && this.views[0].data.map(x => x.value)
      return views ? this.getSum(views) : null
    },
    totalAvg () {
      const users = this.totalUsers
      const views = this.totalViews
      return users && views ? parseFloat((views / users).toFixed(2)) : '-'
    }
  },
  data () {
    return {
      colors: [
        '#de5c5c',
        '#76b955',
        '#4da2cc'
      ],
      chartType: 'line'
    }
  },
  methods: {
    getSum (arr) {
      return arr && arr.length ? arr.reduce((a, b) => a + b) : []
    },
    comma (str) {
      return str ? regExp.comma(str) : '-'
    },
    dateFormat (str) {
      return str ? str.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') : '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboardBox {
  margin-bottom: 60px;
}
.dashboard {
  margin-bottom: 30px;
  padding: 30px 10px 30px 30px;
  text-align: center;
  border: 1px solid $color-lgrey2;
  &.noData {
    padding: 90px 10px;
    font-size: 24px;
    color: $color-lgrey;
  }
  &.summary {
    padding-left: 30px;
    padding-right: 30px;
  }
  .value {
    font-size: 40px;
    font-weight: 700;
  }
  .chartBox {
    height: 360px;
    margin-right: -15px;
    padding: 15px 0 0;
    &.barChart {
      min-height: 500px;
      padding: 15px 0 30px 30px;
    }
  }
  .filterInfo {
    padding: 15px 0;
    border-bottom: 1px solid $color-lgrey2;
  }
  ul {
    display: flex;
  }
  li {
    flex: 1;
    padding: 15px;
    border-left: 1px solid $color-lgrey2;
    &:first-of-type {
      border-left: none;
    }
  }
  .cnt {
    display: block;
    font-size: 2.4em;
    font-weight: 700;
  }
}
.chartSelector {
  display: flex;
  align-items: center;
  justify-content: center;
  .item {
    border: 1px solid $color-lgrey;
    label {
      display: inline-block;
      padding: 8px;
      cursor: pointer;
      span {
        display: block;
        width: 28px;
        height: 28px;
        text-indent: -9999px;
        background-position: 0 0;
        background-size: 100% auto;
        background-repeat: no-repeat;
      }
      .icoLinechart {
        background-image: url('~@/assets/img/ico_linechart.png');
      }
      .icoBarchartH {
        background-image: url('~@/assets/img/ico_barchart_h.png');
      }
      .icoBarchartV {
        background-image: url('~@/assets/img/ico_barchart_v.png');
      }
    }
    :checked + label {
      background-color: $color-dark;
      span {
        background-position: 0 100%;
      }
    }
    & + .item {
      border-left: none;
    }
  }
}
</style>
